"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'video-maker' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 84 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'video-maker' });
    }
    ;
    /**
    * @typedef {Object} videoMakerCustomChangesSaveClickParams
    * @property {string} businessName - business_name
    * @property {boolean} businessNameChanged - business_name_changed
    * @property {string} context - null
    * @property {string} cta - cta
    * @property {boolean} ctaChanged - cta_changed
    * @property {string} currency - currency
    * @property {boolean} fontChanged - font changed
    * @property {number} imageCountEnd - image count after customize
    * @property {number} imageCountStart - image count before customize
    * @property {boolean} mainColorChanged - main_color_changed
    * @property {number} mediaCountFinish - media count after customize
    * @property {number} mediaCountStart - media count before customize
    * @property {string} moodName - mood_name
    * @property {GUID} msid - msid
    * @property {string} orientation - orientation
    * @property {boolean} orientationChanged - video orientation changed
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {number} price - price
    * @property {boolean} priceChanged - price_changed
    * @property {string} productName - product_name
    * @property {boolean} productNameChanged - product_name_changed
    * @property {boolean} reorderInUse - does user reorder images/videos
    * @property {string} saveCustomCorrelationId - unique id for save custom changes
    * @property {boolean} secondaryColorChanged - secondary_color_changed
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} style - style
    * @property {boolean} styleChanged - style_changed
    * @property {boolean} trackChanged - track_changed
    * @property {string} trackName - track_name
    * @property {string} videoId - video Id
    * @property {string} videoInfo - json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
    **/
    /**
     * Name: videoMaker.customChanges.save.click. Evid: 226.
     * Event description: User click on save and continue button in 2nd creation page.
    
     * businessName - Type: string. Desc: business_name
     *
     * businessNameChanged - Type: bool. Desc: business_name_changed
     *
     * context - Type: string.
     *
     * cta - Type: string. Desc: cta
     *
     * ctaChanged - Type: bool. Desc: cta_changed
     *
     * currency - Type: string. Desc: currency
     *
     * fontChanged - Type: bool. Desc: font changed
     *
     * imageCountEnd - Type: numeric. Desc: image count after customize
     *
     * imageCountStart - Type: numeric. Desc: image count before customize
     *
     * mainColorChanged - Type: bool. Desc: main_color_changed
     *
     * mediaCountFinish - Type: numeric. Desc: media count after customize
     *
     * mediaCountStart - Type: numeric. Desc: media count before customize
     *
     * moodName - Type: string. Desc: mood_name
     *
     * msid - Type: guid. Desc: msid
     *
     * orientation - Type: string. Desc: orientation
     *
     * orientationChanged - Type: bool. Desc: video orientation changed
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * price - Type: numeric. Desc: price
     *
     * priceChanged - Type: bool. Desc: price_changed
     *
     * productName - Type: string. Desc: product_name
     *
     * productNameChanged - Type: bool. Desc: product_name_changed
     *
     * reorderInUse - Type: bool. Desc: does user reorder images/videos
     *
     * saveCustomCorrelationId - Type: string. Desc: unique id for save custom changes
     *
     * secondaryColorChanged - Type: bool. Desc: secondary_color_changed
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * style - Type: string. Desc: style
     *
     * styleChanged - Type: bool. Desc: style_changed
     *
     * trackChanged - Type: bool. Desc: track_changed
     *
     * trackName - Type: string. Desc: track_name
     *
     * videoId - Type: string. Desc: video Id
     *
     * videoInfo - Type: string. Desc: json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
     * @param {videoMakerCustomChangesSaveClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomChangesSaveClick = function (params) {
        return this.bi.log(__assign({ evid: 226 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoDeleteFinishedParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} saveCorrelationId - unique id for the session when video saved  (same as it was in evid=210)
    * @property {string} sessionId - null
    * @property {string} source - null
    * @property {string} videoId - .
    * @property {string} videoUrl - .
    **/
    /**
     * Name: videoMaker.video.delete.finished. Evid: 247.
     * Event description: video deleted from BM Video Home tab.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * saveCorrelationId - Type: string. Desc: unique id for the session when video saved  (same as it was in evid=210)
     *
     * sessionId - Type: string.
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: .
     *
     * videoUrl - Type: string. Desc: .
     * @param {videoMakerVideoDeleteFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoDeleteFinished = function (params) {
        return this.bi.log(__assign({ evid: 247 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeMusicFiltersClickParams
    * @property {string} context - context
    * @property {GUID} msid - msid
    * @property {string} origin - app
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - installed_apps / quick_actions
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.music.filters.click. Evid: 237.
     * Event description: User click on filters music in customize page (music tab).
    
     * context - Type: string. Desc: context
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: app
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: installed_apps / quick_actions
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeMusicFiltersClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeMusicFiltersClick = function (params) {
        return this.bi.log(__assign({ evid: 237 }, params));
    };
    /**
    * @typedef {Object} videoMakerShareClickParams
    * @property {string} buttonName - button_name
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.share.click. Evid: 214.
     * Event description: User click on share button after saved video and customize again.
    
     * buttonName - Type: string. Desc: button_name
     *
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerShareClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerShareClick = function (params) {
        return this.bi.log(__assign({ evid: 214 }, params));
    };
    /**
    * @typedef {Object} videoMakerUpgradePopUpOpenParams
    * @property {string} button - general / ascend
    * @property {string} context - context
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name of the upgrade button
    * @property {string} platform - ios/android
    * @property {number} quota - (how many videos left) 1, 9, 0 etc
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - stores/promote
    * @property {string} type - upgrade / upgrade_ascend / over_quota
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.upgradePopUp.open. Evid: 241.
     * Event description: Upgrade to get more videos or Out of Quota pop up open.
    
     * button - Type: string. Desc: general / ascend
     *
     * context - Type: string. Desc: context
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name of the upgrade button
     *
     * platform - Type: string. Desc: ios/android
     *
     * quota - Type: numeric. Desc: (how many videos left) 1, 9, 0 etc
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: stores/promote
     *
     * type - Type: string. Desc: upgrade / upgrade_ascend / over_quota
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerUpgradePopUpOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerUpgradePopUpOpen = function (params) {
        return this.bi.log(__assign({ evid: 241 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeVideoButtonClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page_name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} style - style
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.customizeVideo.button.click. Evid: 207.
     * Event description: User click on customize video button.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page_name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * style - Type: string. Desc: style
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerCustomizeVideoButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeVideoButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 207 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeMusicPlayClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.music.play.click. Evid: 221.
     * Event description: User clicked on play music in customize page (music tab).
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeMusicPlayClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeMusicPlayClick = function (params) {
        return this.bi.log(__assign({ evid: 221 }, params));
    };
    /**
    * @typedef {Object} makerDeleteVideoPopUpButtonClickParams
    * @property {string} buttonName - button_name
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - video_id
    **/
    /**
     * Name: maker.deleteVideo.popUp.button.click. Evid: 232.
     * Event description: User clicks on a button in delete video popup.
    
     * buttonName - Type: string. Desc: button_name
     *
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: video_id
     * @param {makerDeleteVideoPopUpButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.makerDeleteVideoPopUpButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 232 }, params));
    };
    /**
    * @typedef {Object} videoMakerPopUpShownParams
    * @property {string} context - .
    * @property {string} message - message text
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - n which page this message open
    * @property {string} platform - ios/android
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - video_id (file_id in case we don't have video_id)
    **/
    /**
     * Name: videoMaker.PopUp.shown. Evid: 252.
     * Event description: popup message shown.
    
     * context - Type: string. Desc: .
     *
     * message - Type: string. Desc: message text
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: n which page this message open
     *
     * platform - Type: string. Desc: ios/android
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: video_id (file_id in case we don't have video_id)
     * @param {videoMakerPopUpShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerPopUpShown = function (params) {
        return this.bi.log(__assign({ evid: 252 }, params));
    };
    /**
    * @typedef {Object} videoMakerUpgradePopUpClickParams
    * @property {string} button - cancel / close / got_it / upgrade
    * @property {string} context - context
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name of the upgrade button
    * @property {string} platform - ios/android
    * @property {number} quota - (how many videos left) 1, 9, 0 etc
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - stores/promote
    * @property {string} type - upgrade / upgrade_ascend / over_quota
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.upgradePopUp.click. Evid: 242.
     * Event description: User clicks on Upgrade to get more videos or Out of Quota pop up.
    
     * button - Type: string. Desc: cancel / close / got_it / upgrade
     *
     * context - Type: string. Desc: context
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name of the upgrade button
     *
     * platform - Type: string. Desc: ios/android
     *
     * quota - Type: numeric. Desc: (how many videos left) 1, 9, 0 etc
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: stores/promote
     *
     * type - Type: string. Desc: upgrade / upgrade_ascend / over_quota
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerUpgradePopUpClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerUpgradePopUpClick = function (params) {
        return this.bi.log(__assign({ evid: 242 }, params));
    };
    /**
    * @typedef {Object} videoMakerPlayClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} playOrigin - click,keyboard,auto etc. - Not implemented
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} style - style
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.play.click. Evid: 211.
     * Event description: User click on play video (Can click on button, keyboard, autoplay if we will have) - every time play attempt.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * playOrigin - Type: string. Desc: click,keyboard,auto etc. - Not implemented
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * style - Type: string. Desc: style
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerPlayClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerPlayClick = function (params) {
        return this.bi.log(__assign({ evid: 211 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoLoaderTryAgainClickParams
    * @property {string} context - null
    * @property {string} correlationId - unique id for every video created
    * @property {string} errorType - If not success error from server
    * @property {boolean} isDescriptionExist - if product have description
    * @property {boolean} isTitleExist - if product have title
    * @property {GUID} msid - msid
    * @property {number} numberOfPictures - How many pic product has
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    **/
    /**
     * Name: videoMaker.videoLoader.tryAgain.click. Evid: 206.
     * Event description: User click on try again when video creation failed.
    
     * context - Type: string.
     *
     * correlationId - Type: string. Desc: unique id for every video created
     *
     * errorType - Type: string. Desc: If not success error from server
     *
     * isDescriptionExist - Type: bool. Desc: if product have description
     *
     * isTitleExist - Type: bool. Desc: if product have title
     *
     * msid - Type: guid. Desc: msid
     *
     * numberOfPictures - Type: numeric. Desc: How many pic product has
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     * @param {videoMakerVideoLoaderTryAgainClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoLoaderTryAgainClick = function (params) {
        return this.bi.log(__assign({ evid: 206 }, params));
    };
    /**
    * @typedef {Object} videoMakerPopUpClickParams
    * @property {string} buttonName - learnMore/ close / done
    * @property {string} context - .
    * @property {string} message - message text
    * @property {GUID} msid - msid
    * @property {string} origin - null
    * @property {string} pageName - null
    * @property {string} platform - ios/android
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - video_id (file_id in case we don't have video_id)
    **/
    /**
     * Name: videoMaker.PopUp.click. Evid: 253.
     * Event description: popup message click.
    
     * buttonName - Type: string. Desc: learnMore/ close / done
     *
     * context - Type: string. Desc: .
     *
     * message - Type: string. Desc: message text
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string.
     *
     * pageName - Type: string.
     *
     * platform - Type: string. Desc: ios/android
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: video_id (file_id in case we don't have video_id)
     * @param {videoMakerPopUpClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerPopUpClick = function (params) {
        return this.bi.log(__assign({ evid: 253 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeContentAddMediaFinishedParams
    * @property {string} context - null
    * @property {string} errorType - error if failed
    * @property {boolean} isSuccess - is_success
    * @property {string} mediaType - image,video,logo
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.content.addMedia.finished. Evid: 220.
     * Event description: Add media finished in customize tab /logo in business tab.
    
     * context - Type: string.
     *
     * errorType - Type: string. Desc: error if failed
     *
     * isSuccess - Type: bool. Desc: is_success
     *
     * mediaType - Type: string. Desc: image,video,logo
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeContentAddMediaFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeContentAddMediaFinished = function (params) {
        return this.bi.log(__assign({ evid: 220 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoActionsClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - same as in 210, but without prefix
    * @property {string} source - null
    * @property {string} target - actions_click / share / download / duplicate / delete / edit / play
    * @property {string} videoId - .
    * @property {string} videoUrl - .
    **/
    /**
     * Name: videoMaker.videoActions.click. Evid: 246.
     * Event description: user click on some action on video in BM Video Home tab.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: same as in 210, but without prefix
     *
     * source - Type: string.
     *
     * target - Type: string. Desc: actions_click / share / download / duplicate / delete / edit / play
     *
     * videoId - Type: string. Desc: .
     *
     * videoUrl - Type: string. Desc: .
     * @param {videoMakerVideoActionsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoActionsClick = function (params) {
        return this.bi.log(__assign({ evid: 246 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeContentAddMediaStartedParams
    * @property {string} context - null
    * @property {string} mediaType - image,video,logo
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.content.addMedia.started. Evid: 219.
     * Event description: Add media started in customize tab / logo in business tab.
    
     * context - Type: string.
     *
     * mediaType - Type: string. Desc: image,video,logo
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeContentAddMediaStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeContentAddMediaStarted = function (params) {
        return this.bi.log(__assign({ evid: 219 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeBackClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} tabName - tab name
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.back.click. Evid: 217.
     * Event description: User click on a back button / discard changes  in customize screen.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * tabName - Type: string. Desc: tab name
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeBackClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeBackClick = function (params) {
        return this.bi.log(__assign({ evid: 217 }, params));
    };
    /**
    * @typedef {Object} videoMakerSaveVideoFinishedParams
    * @property {string} context - null
    * @property {string} errorType - error if save fail
    * @property {boolean} isSuccess - is success
    * @property {number} loadingTime - loadingTime
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {boolean} premiumMessageShown - t / f
    * @property {number} quota - (how many videos left) 1, 9, 0 etc
    * @property {string} saveCorrelationId - unique id for the session when video saved (different from correlation In 206)
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} style - style
    * @property {string} type - upgrade / upgrade_ascend / over_quota
    * @property {string} videoId - unique id for each video created
    * @property {string} videoUrl - video url
    **/
    /**
     * Name: videoMaker.saveVideo.finished. Evid: 210.
     * Event description: video save process finished.
    
     * context - Type: string.
     *
     * errorType - Type: string. Desc: error if save fail
     *
     * isSuccess - Type: bool. Desc: is success
     *
     * loadingTime - Type: numeric. Desc: loadingTime
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * premiumMessageShown - Type: bool. Desc: t / f
     *
     * quota - Type: numeric. Desc: (how many videos left) 1, 9, 0 etc
     *
     * saveCorrelationId - Type: string. Desc: unique id for the session when video saved (different from correlation In 206)
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * style - Type: string. Desc: style
     *
     * type - Type: string. Desc: upgrade / upgrade_ascend / over_quota
     *
     * videoId - Type: string. Desc: unique id for each video created
     *
     * videoUrl - Type: string. Desc: video url
     * @param {videoMakerSaveVideoFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerSaveVideoFinished = function (params) {
        return this.bi.log(__assign({ evid: 210 }, params));
    };
    /**
    * @typedef {Object} videoMakerShareVideoFinishedParams
    * @property {string} application_id - over app id video was shared
    * @property {string} buttonName - button_name
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - app
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - installed_apps / quick_actions
    * @property {string} videoId - unique id for each video created
    * @property {string} videoUrl - video URL
    **/
    /**
     * Name: videoMaker.shareVideo.finished. Evid: 239.
     * Event description: User successfully shared video via social networks or other mobile apps.
    
     * application_id - Type: string. Desc: over app id video was shared
     *
     * buttonName - Type: string. Desc: button_name
     *
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: app
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: installed_apps / quick_actions
     *
     * videoId - Type: string. Desc: unique id for each video created
     *
     * videoUrl - Type: string. Desc: video URL
     * @param {videoMakerShareVideoFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerShareVideoFinished = function (params) {
        return this.bi.log(__assign({ evid: 239 }, params));
    };
    /**
    * @typedef {Object} videoMakerFeedbackAnswerClickParams
    * @property {string} choice - my_site / social_media / both / skip
    * @property {string} context - new / old
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.feedback.answer.click. Evid: 234.
     * Event description: user answer at Feedback dialog in Video Maker.
    
     * choice - Type: string. Desc: my_site / social_media / both / skip
     *
     * context - Type: string. Desc: new / old
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerFeedbackAnswerClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerFeedbackAnswerClick = function (params) {
        return this.bi.log(__assign({ evid: 234 }, params));
    };
    /**
    * @typedef {Object} videoMakerDuplicateAndEditClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.duplicateAndEdit.click. Evid: 228.
     * Event description: User click on "duplicate and click"  button when edit_page open from VM home.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerDuplicateAndEditClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerDuplicateAndEditClick = function (params) {
        return this.bi.log(__assign({ evid: 228 }, params));
    };
    /**
    * @typedef {Object} videoMakerErrorShownParams
    * @property {string} context - .
    * @property {string} errorMessage - error name
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - n which page this error open
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - video_id (file_id in case we don't have video_id)
    **/
    /**
     * Name: videoMaker.error.shown. Evid: 243.
     * Event description: error message shown.
    
     * context - Type: string. Desc: .
     *
     * errorMessage - Type: string. Desc: error name
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: n which page this error open
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: video_id (file_id in case we don't have video_id)
     * @param {videoMakerErrorShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerErrorShown = function (params) {
        return this.bi.log(__assign({ evid: 243 }, params));
    };
    /**
    * @typedef {Object} videoMakerErrorClickParams
    * @property {string} buttonName - learnMore/ close / done
    * @property {string} context - .
    * @property {string} errorMessage - error name
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - n which page this error open
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - video_id (file_id in case we don't have video_id)
    **/
    /**
     * Name: videoMaker.error.click. Evid: 244.
     * Event description: error message click.
    
     * buttonName - Type: string. Desc: learnMore/ close / done
     *
     * context - Type: string. Desc: .
     *
     * errorMessage - Type: string. Desc: error name
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: n which page this error open
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: video_id (file_id in case we don't have video_id)
     * @param {videoMakerErrorClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerErrorClick = function (params) {
        return this.bi.log(__assign({ evid: 244 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeMusicPlayStartParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.music.play.start. Evid: 222.
     * Event description: Music play  start  in customize page (music tab).
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeMusicPlayStartParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeMusicPlayStart = function (params) {
        return this.bi.log(__assign({ evid: 222 }, params));
    };
    /**
    * @typedef {Object} videoMakerAppNavigationClickParams
    * @property {string} buttonName - back / next / add / close
    * @property {string} context - context
    * @property {GUID} msid - msid
    * @property {string} origin - app
    * @property {string} pageName - Page Name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - installed_apps / quick_actions
    **/
    /**
     * Name: videoMaker.app.navigation.click. Evid: 235.
     * Event description: User click on a Back / Next / Add / Close button.
    
     * buttonName - Type: string. Desc: back / next / add / close
     *
     * context - Type: string. Desc: context
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: app
     *
     * pageName - Type: string. Desc: Page Name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: installed_apps / quick_actions
     * @param {videoMakerAppNavigationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerAppNavigationClick = function (params) {
        return this.bi.log(__assign({ evid: 235 }, params));
    };
    /**
    * @typedef {Object} videoMakerCreateVideoButtonClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - the page where user click on X
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    **/
    /**
     * Name: videoMaker.page.close.click. Evid: 202.
     * Event description: User click on X button to close app.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: the page where user click on X
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     * @param {videoMakerCreateVideoButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCreateVideoButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 202 }, params));
    };
    /**
    * @typedef {Object} videoMakerButtonClickParams
    * @property {string} buttonName - OK / cancel / apply etc.
    * @property {string} context - context
    * @property {GUID} msid - msid
    * @property {string} origin - app
    * @property {string} pageName - Page Name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - installed_apps / quick_actions
    **/
    /**
     * Name: videoMaker.button.click. Evid: 238.
     * Event description: User click on a OK / Cancel / Apply  etc..
    
     * buttonName - Type: string. Desc: OK / cancel / apply etc.
     *
     * context - Type: string. Desc: context
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: app
     *
     * pageName - Type: string. Desc: Page Name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: installed_apps / quick_actions
     * @param {videoMakerButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 238 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeApplyAndPreviewClickParams
    * @property {string} businessName - business_name
    * @property {boolean} businessNameChanged - business_name_changed
    * @property {string} context - null
    * @property {string} cta - cta
    * @property {boolean} ctaChanged - cta_changed
    * @property {string} currency - currency
    * @property {boolean} fontChanged - font changed
    * @property {number} imageCountEnd - image count after customize
    * @property {number} imageCountStart - image count before customize
    * @property {boolean} mainColorChanged - main_color_changed
    * @property {number} mediaCountFinish - media count after customize
    * @property {number} mediaCountStart - media count before customize
    * @property {string} moodName - mood_name
    * @property {GUID} msid - msid
    * @property {string} orientation - orientation
    * @property {boolean} orientationChanged - video orientation changed
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {number} price - price
    * @property {boolean} priceChanged - price_changed
    * @property {string} productName - product_name
    * @property {boolean} productNameChanged - product_name_changed
    * @property {boolean} reorderInUse - does user reorder images/videos
    * @property {boolean} secondaryColorChanged - secondary_color_changed
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} style - style
    * @property {boolean} styleChanged - style_changed
    * @property {string} tabName - tab name
    * @property {boolean} trackChanged - track_changed
    * @property {string} trackName - track_name
    * @property {string} userPrice - price instead of price field
    * @property {string} videoId - video Id
    * @property {string} videoInfo - json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
    **/
    /**
     * Name: videoMaker.customize.applyAndPreview.click. Evid: 223.
     * Event description: User click on apply and review button in customize page.
    
     * businessName - Type: string. Desc: business_name
     *
     * businessNameChanged - Type: bool. Desc: business_name_changed
     *
     * context - Type: string.
     *
     * cta - Type: string. Desc: cta
     *
     * ctaChanged - Type: bool. Desc: cta_changed
     *
     * currency - Type: string. Desc: currency
     *
     * fontChanged - Type: bool. Desc: font changed
     *
     * imageCountEnd - Type: numeric. Desc: image count after customize
     *
     * imageCountStart - Type: numeric. Desc: image count before customize
     *
     * mainColorChanged - Type: bool. Desc: main_color_changed
     *
     * mediaCountFinish - Type: numeric. Desc: media count after customize
     *
     * mediaCountStart - Type: numeric. Desc: media count before customize
     *
     * moodName - Type: string. Desc: mood_name
     *
     * msid - Type: guid. Desc: msid
     *
     * orientation - Type: string. Desc: orientation
     *
     * orientationChanged - Type: bool. Desc: video orientation changed
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * price - Type: numeric. Desc: price
     *
     * priceChanged - Type: bool. Desc: price_changed
     *
     * productName - Type: string. Desc: product_name
     *
     * productNameChanged - Type: bool. Desc: product_name_changed
     *
     * reorderInUse - Type: bool. Desc: does user reorder images/videos
     *
     * secondaryColorChanged - Type: bool. Desc: secondary_color_changed
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * style - Type: string. Desc: style
     *
     * styleChanged - Type: bool. Desc: style_changed
     *
     * tabName - Type: string. Desc: tab name
     *
     * trackChanged - Type: bool. Desc: track_changed
     *
     * trackName - Type: string. Desc: track_name
     *
     * userPrice - Type: string. Desc: price instead of price field
     *
     * videoId - Type: string. Desc: video Id
     *
     * videoInfo - Type: string. Desc: json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
     * @param {videoMakerCustomizeApplyAndPreviewClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeApplyAndPreviewClick = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoCreationStartedParams
    * @property {string} businessName - business_name
    * @property {boolean} businessNameChanged - business_name_changed
    * @property {string} context - null
    * @property {string} correlationId - unique id for each video created
    * @property {string} cta - cta
    * @property {boolean} ctaChanged - cta_changed
    * @property {string} currency - currency
    * @property {string} entityId - product_id from stores
    * @property {boolean} fontChanged - font changed
    * @property {number} imageCountEnd - image count after customize
    * @property {number} imageCountStart - image count before customize
    * @property {boolean} isDescriptionExist - if product have description
    * @property {boolean} isFirst - first time video creation or after customization
    * @property {boolean} isTitleExist - if product have title
    * @property {boolean} mainColorChanged - main_color_changed
    * @property {number} mediaCountFinish - media count after customize
    * @property {number} mediaCountStart - media count before customize
    * @property {string} moodName - mood_name
    * @property {GUID} msid - msid
    * @property {string} orientation - orientation
    * @property {boolean} orientationChanged - video orientation changed
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {number} price - price
    * @property {boolean} priceChanged - price_changed
    * @property {string} productName - product_name
    * @property {boolean} productNameChanged - product_name_changed
    * @property {boolean} reorderInUse - does user reorder images/videos
    * @property {string} saveCustomCorrelationId - unique id for save custom changes
    * @property {boolean} secondaryColorChanged - secondary_color_changed
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} style - style
    * @property {boolean} styleChanged - style_changed
    * @property {string} tabName - tab name
    * @property {boolean} trackChanged - track_changed
    * @property {string} trackName - track_name
    * @property {string} videoId - video Id
    * @property {string} videoInfo - json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
    **/
    /**
     * Name: videoMaker.video.creation.started. Evid: 204.
     * Event description: Video creation started (first time or after customized).
    
     * businessName - Type: string. Desc: business_name
     *
     * businessNameChanged - Type: bool. Desc: business_name_changed
     *
     * context - Type: string.
     *
     * correlationId - Type: string. Desc: unique id for each video created
     *
     * cta - Type: string. Desc: cta
     *
     * ctaChanged - Type: bool. Desc: cta_changed
     *
     * currency - Type: string. Desc: currency
     *
     * entityId - Type: string. Desc: product_id from stores
     *
     * fontChanged - Type: bool. Desc: font changed
     *
     * imageCountEnd - Type: numeric. Desc: image count after customize
     *
     * imageCountStart - Type: numeric. Desc: image count before customize
     *
     * isDescriptionExist - Type: bool. Desc: if product have description
     *
     * isFirst - Type: bool. Desc: first time video creation or after customization
     *
     * isTitleExist - Type: bool. Desc: if product have title
     *
     * mainColorChanged - Type: bool. Desc: main_color_changed
     *
     * mediaCountFinish - Type: numeric. Desc: media count after customize
     *
     * mediaCountStart - Type: numeric. Desc: media count before customize
     *
     * moodName - Type: string. Desc: mood_name
     *
     * msid - Type: guid. Desc: msid
     *
     * orientation - Type: string. Desc: orientation
     *
     * orientationChanged - Type: bool. Desc: video orientation changed
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * price - Type: numeric. Desc: price
     *
     * priceChanged - Type: bool. Desc: price_changed
     *
     * productName - Type: string. Desc: product_name
     *
     * productNameChanged - Type: bool. Desc: product_name_changed
     *
     * reorderInUse - Type: bool. Desc: does user reorder images/videos
     *
     * saveCustomCorrelationId - Type: string. Desc: unique id for save custom changes
     *
     * secondaryColorChanged - Type: bool. Desc: secondary_color_changed
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * style - Type: string. Desc: style
     *
     * styleChanged - Type: bool. Desc: style_changed
     *
     * tabName - Type: string. Desc: tab name
     *
     * trackChanged - Type: bool. Desc: track_changed
     *
     * trackName - Type: string. Desc: track_name
     *
     * videoId - Type: string. Desc: video Id
     *
     * videoInfo - Type: string. Desc: json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
     * @param {videoMakerVideoCreationStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoCreationStarted = function (params) {
        return this.bi.log(__assign({ evid: 204 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeContentRemoveClickParams
    * @property {string} context - null
    * @property {string} mediaType - image,video
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.content.remove.click. Evid: 216.
     * Event description: User click on a remove content  in customize screen (content tab).
    
     * context - Type: string.
     *
     * mediaType - Type: string. Desc: image,video
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeContentRemoveClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeContentRemoveClick = function (params) {
        return this.bi.log(__assign({ evid: 216 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeTabClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} prevTab - prev tab name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} tabName - tab name
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.tab.click. Evid: 213.
     * Event description: User click on a tab in customize screen.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * prevTab - Type: string. Desc: prev tab name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * tabName - Type: string. Desc: tab name
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeTabClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeTabClick = function (params) {
        return this.bi.log(__assign({ evid: 213 }, params));
    };
    /**
    * @typedef {Object} videoMakerBusinessInfoLogoActionPerformedParams
    * @property {string} actionName - add/change/delete
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - stores/promote
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.businessInfo.logo.action.performed. Evid: 224.
     * Event description: User add/change/delete logo.
    
     * actionName - Type: string. Desc: add/change/delete
     *
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: stores/promote
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerBusinessInfoLogoActionPerformedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerBusinessInfoLogoActionPerformed = function (params) {
        return this.bi.log(__assign({ evid: 224 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoAddedToProductPageParams
    * @property {string} context - context
    * @property {GUID} msid - msid
    * @property {string} origin - app
    * @property {string} pageName - Page Name
    * @property {string} productId - productId
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - installed_apps / quick_actions
    * @property {boolean} isSuccess - is video added success
    * @property {string} videoId - video_id
    **/
    /**
     * Name: videoMaker.videoAddedToProductPage. Evid: 240.
     * Event description: Video added to product page.
    
     * context - Type: string. Desc: context
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: app
     *
     * pageName - Type: string. Desc: Page Name
     *
     * productId - Type: string. Desc: productId
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: installed_apps / quick_actions
     *
     * isSuccess - Type: bool. Desc: is video added success
     *
     * videoId - Type: string. Desc: video_id
     * @param {videoMakerVideoAddedToProductPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoAddedToProductPage = function (params) {
        return this.bi.log(__assign({ evid: 240 }, params));
    };
    /**
    * @typedef {Object} videoMakerShareScreenHomeButtonClickParams
    * @property {string} buttonName - help / watch_video / VM home tab entry
    * @property {string} context - .
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - promote-video-home
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.shareScreenHome.button.click. Evid: 250.
     * Event description: User clicks on a button in "share your video" screen, opened from VM Home - My Videos tab.
    
     * buttonName - Type: string. Desc: help / watch_video / VM home tab entry
     *
     * context - Type: string. Desc: .
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: promote-video-home
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerShareScreenHomeButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerShareScreenHomeButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 250 }, params));
    };
    /**
    * @typedef {Object} videoMakerSaveVideoStartedParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} saveCorrelationId - unique id for the session when video saved (different from correlation In 206)
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} style - style
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.saveVideo.started. Evid: 209.
     * Event description: video save process started.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * saveCorrelationId - Type: string. Desc: unique id for the session when video saved (different from correlation In 206)
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * style - Type: string. Desc: style
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerSaveVideoStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerSaveVideoStarted = function (params) {
        return this.bi.log(__assign({ evid: 209 }, params));
    };
    /**
    * @typedef {Object} videoMakerEditTemplateClickParams
    * @property {string} context - null
    * @property {string} entity_id - video template
    * @property {string} format - square / landscape / portrait
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - null
    * @property {string} source - .
    **/
    /**
     * Name: videoMaker.editTemplate.click. Evid: 248.
     * Event description: click on one of the templates in BM Templates tab.
    
     * context - Type: string.
     *
     * entity_id - Type: string. Desc: video template
     *
     * format - Type: string. Desc: square / landscape / portrait
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string.
     *
     * source - Type: string. Desc: .
     * @param {videoMakerEditTemplateClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerEditTemplateClick = function (params) {
        return this.bi.log(__assign({ evid: 248 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoCreationFinishedParams
    * @property {string} businessName - business_name
    * @property {boolean} businessNameChanged - business_name_changed
    * @property {string} context - null
    * @property {string} correlationId - unique id for every video created
    * @property {string} cta - cta
    * @property {boolean} ctaChanged - cta_changed
    * @property {string} currency - currency
    * @property {string} entityId - product_id from stores
    * @property {string} errorType - error if failed
    * @property {boolean} fontChanged - font changed
    * @property {number} imageCountEnd - image count after customize
    * @property {number} imageCountStart - image count before customize
    * @property {boolean} isDescriptionExist - if product have description
    * @property {boolean} isSuccess - is success
    * @property {boolean} isTitleExist - if product have title
    * @property {boolean} mainColorChanged - main_color_changed
    * @property {number} mediaCountFinish - media count after customize
    * @property {number} mediaCountStart - media count before customize
    * @property {string} moodName - mood_name
    * @property {GUID} msid - msid
    * @property {string} orientation - orientation
    * @property {boolean} orientationChanged - video orientation changed
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {boolean} premiumMessageShown - t/f
    * @property {number} price - price
    * @property {boolean} priceChanged - price_changed
    * @property {string} productName - product_name
    * @property {boolean} productNameChanged - product_name_changed
    * @property {number} quota - (how many videos left) 1, 9, 0 etc
    * @property {boolean} reorderInUse - does user reorder images/videos
    * @property {string} saveCorrelationId - Magisto session id
    * @property {string} saveCustomCorrelationId - unique id for save custom changes
    * @property {boolean} secondaryColorChanged - secondary_color_changed
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} style - style
    * @property {boolean} styleChanged - style_changed
    * @property {string} tabName - tab name
    * @property {boolean} trackChanged - track_changed
    * @property {string} trackName - track_name
    * @property {string} type - upgrade / upgrade_ascend / over_quota
    * @property {number} videoCount - How many videos we created to user
    * @property {number} videoCreationTime - time to create video in ms
    * @property {string} videoId - video Id
    * @property {string} videoInfo - json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
    **/
    /**
     * Name: videoMaker.video.creation.finished. Evid: 205.
     * Event description: Video creation finished (first time or after customized).
    
     * businessName - Type: string. Desc: business_name
     *
     * businessNameChanged - Type: bool. Desc: business_name_changed
     *
     * context - Type: string.
     *
     * correlationId - Type: string. Desc: unique id for every video created
     *
     * cta - Type: string. Desc: cta
     *
     * ctaChanged - Type: bool. Desc: cta_changed
     *
     * currency - Type: string. Desc: currency
     *
     * entityId - Type: string. Desc: product_id from stores
     *
     * errorType - Type: string. Desc: error if failed
     *
     * fontChanged - Type: bool. Desc: font changed
     *
     * imageCountEnd - Type: numeric. Desc: image count after customize
     *
     * imageCountStart - Type: numeric. Desc: image count before customize
     *
     * isDescriptionExist - Type: bool. Desc: if product have description
     *
     * isSuccess - Type: bool. Desc: is success
     *
     * isTitleExist - Type: bool. Desc: if product have title
     *
     * mainColorChanged - Type: bool. Desc: main_color_changed
     *
     * mediaCountFinish - Type: numeric. Desc: media count after customize
     *
     * mediaCountStart - Type: numeric. Desc: media count before customize
     *
     * moodName - Type: string. Desc: mood_name
     *
     * msid - Type: guid. Desc: msid
     *
     * orientation - Type: string. Desc: orientation
     *
     * orientationChanged - Type: bool. Desc: video orientation changed
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * premiumMessageShown - Type: bool. Desc: t/f
     *
     * price - Type: numeric. Desc: price
     *
     * priceChanged - Type: bool. Desc: price_changed
     *
     * productName - Type: string. Desc: product_name
     *
     * productNameChanged - Type: bool. Desc: product_name_changed
     *
     * quota - Type: numeric. Desc: (how many videos left) 1, 9, 0 etc
     *
     * reorderInUse - Type: bool. Desc: does user reorder images/videos
     *
     * saveCorrelationId - Type: string. Desc: Magisto session id
     *
     * saveCustomCorrelationId - Type: string. Desc: unique id for save custom changes
     *
     * secondaryColorChanged - Type: bool. Desc: secondary_color_changed
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * style - Type: string. Desc: style
     *
     * styleChanged - Type: bool. Desc: style_changed
     *
     * tabName - Type: string. Desc: tab name
     *
     * trackChanged - Type: bool. Desc: track_changed
     *
     * trackName - Type: string. Desc: track_name
     *
     * type - Type: string. Desc: upgrade / upgrade_ascend / over_quota
     *
     * videoCount - Type: numeric. Desc: How many videos we created to user
     *
     * videoCreationTime - Type: numeric. Desc: time to create video in ms
     *
     * videoId - Type: string. Desc: video Id
     *
     * videoInfo - Type: string. Desc: json for 4 fields in in video info: { field_name: “opening_text etc” field_value: “value” field_changed: true/false }
     * @param {videoMakerVideoCreationFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoCreationFinished = function (params) {
        return this.bi.log(__assign({ evid: 205 }, params));
    };
    /**
    * @typedef {Object} sendParams
    * @property {string} context - null
    * @property {boolean} isFirst - If app loaded for the first time in site
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    **/
    /**
     * Name: videoMaker.app.pre-load. Evid: 200.
     * Event description: Video maker modal pre loaded - only to welcome screen.
    
     * context - Type: string.
     *
     * isFirst - Type: bool. Desc: If app loaded for the first time in site
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     * @param {sendParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.send = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} makerDeleteVideoPopUpOpenedParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - n which page this pop up open
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - video_id
    **/
    /**
     * Name: maker.deleteVideo.popUp.opened. Evid: 231.
     * Event description: Delete video popup opened.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: n which page this pop up open
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: video_id
     * @param {makerDeleteVideoPopUpOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.makerDeleteVideoPopUpOpened = function (params) {
        return this.bi.log(__assign({ evid: 231 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoSavedButtonClickParams
    * @property {string} buttonName - facebook/youtube/product/learn_more
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.videoSaved.button.click. Evid: 230.
     * Event description: User clicks on a button in "Get Your video out there" screen.
    
     * buttonName - Type: string. Desc: facebook/youtube/product/learn_more
     *
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerVideoSavedButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoSavedButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 230 }, params));
    };
    /**
    * @typedef {Object} videoMakerContentAddMediaFromSourceClickParams
    * @property {string} context - context
    * @property {string} media_source - photo / from_phone / media_manager
    * @property {GUID} msid - msid
    * @property {string} origin - app
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - installed_apps / quick_actions
    **/
    /**
     * Name: videoMaker.content.addMedia.fromSource.click. Evid: 236.
     * Event description: User click on "Take a photo" "Choose from Phone", "Select from Media Manager" after "Add media" button Click.
    
     * context - Type: string. Desc: context
     *
     * media_source - Type: string. Desc: photo / from_phone / media_manager
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: app
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: installed_apps / quick_actions
     * @param {videoMakerContentAddMediaFromSourceClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerContentAddMediaFromSourceClick = function (params) {
        return this.bi.log(__assign({ evid: 236 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoStartPlayParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} playOrigin - click,keyboard,auto etc. - Not implemented
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} style - style
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.video.start.play. Evid: 212.
     * Event description: Video start to play.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * playOrigin - Type: string. Desc: click,keyboard,auto etc. - Not implemented
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * style - Type: string. Desc: style
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerVideoStartPlayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoStartPlay = function (params) {
        return this.bi.log(__assign({ evid: 212 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeNextClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} tabName - tab name
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.customize.next.click. Evid: 215.
     * Event description: User click on a next button  in customize screen.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * tabName - Type: string. Desc: tab name
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeNextClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeNextClick = function (params) {
        return this.bi.log(__assign({ evid: 215 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoReadyBackClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.videoReady.back.click. Evid: 229.
     * Event description: User click on a back button  in video ready screen.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerVideoReadyBackClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoReadyBackClick = function (params) {
        return this.bi.log(__assign({ evid: 229 }, params));
    };
    /**
    * @typedef {Object} videoMakerVideoHomeTabClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - null
    * @property {string} source - .
    * @property {string} target - templates / my_videos
    **/
    /**
     * Name: videoMaker.videoHome.tab.click. Evid: 249.
     * Event description: chose  'templates' or 'my_videos' tab in BM Video Maker Home.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string.
     *
     * source - Type: string. Desc: .
     *
     * target - Type: string. Desc: templates / my_videos
     * @param {videoMakerVideoHomeTabClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerVideoHomeTabClick = function (params) {
        return this.bi.log(__assign({ evid: 249 }, params));
    };
    /**
    * @typedef {Object} videoMakerPageCloseClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    **/
    /**
     * Name: videoMaker.app.closed. Evid: 203.
     * Event description: Video Maker app closed.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     * @param {videoMakerPageCloseClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerPageCloseClick = function (params) {
        return this.bi.log(__assign({ evid: 203 }, params));
    };
    /**
    * @typedef {Object} videoMakerCreateVideoClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - same as in 210, but without prefix
    * @property {string} source - null
    * @property {string} tabName - templates / my_videos
    * @property {string} target - create_new_video_top / square / landscape / portrait / create_new_video_gallery (in case of plus click in a gallery) / get_started
    **/
    /**
     * Name: videoMaker.createVideo.click. Evid: 245.
     * Event description: user click on create video in BM Video Home tab.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: same as in 210, but without prefix
     *
     * source - Type: string.
     *
     * tabName - Type: string. Desc: templates / my_videos
     *
     * target - Type: string. Desc: create_new_video_top / square / landscape / portrait / create_new_video_gallery (in case of plus click in a gallery) / get_started
     * @param {videoMakerCreateVideoClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCreateVideoClick = function (params) {
        return this.bi.log(__assign({ evid: 245 }, params));
    };
    /**
    * @typedef {Object} videoMakerFeedbackShownParams
    * @property {string} context - new / old
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.feedback.shown. Evid: 233.
     * Event description: Feedback dialog in Video Maker was showen for user.
    
     * context - Type: string. Desc: new / old
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerFeedbackShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerFeedbackShown = function (params) {
        return this.bi.log(__assign({ evid: 233 }, params));
    };
    /**
    * @typedef {Object} videoMakerUpgradeButtonClickParams
    * @property {string} button - general / ascend
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name of the upgrade button
    * @property {number} quota - (how many videos left) 1, 9, 0 etc
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - stores/promote
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.upgrade.button.click. Evid: 225.
     * Event description: User clicks on the upgrade button.
    
     * button - Type: string. Desc: general / ascend
     *
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name of the upgrade button
     *
     * quota - Type: numeric. Desc: (how many videos left) 1, 9, 0 etc
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: stores/promote
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerUpgradeButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerUpgradeButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 225 }, params));
    };
    /**
    * @typedef {Object} videoMakerCustomizeContentAddMediaClickParams
    * @property {string} context - null
    * @property {string} mediaType - image,video
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - null
    * @property {string} videoId - video Id
    **/
    /**
     * Name: videoMaker.content.addMedia.click. Evid: 218.
     * Event description: User click on a add media button  in customize screen.
    
     * context - Type: string.
     *
     * mediaType - Type: string. Desc: image,video
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string.
     *
     * videoId - Type: string. Desc: video Id
     * @param {videoMakerCustomizeContentAddMediaClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerCustomizeContentAddMediaClick = function (params) {
        return this.bi.log(__assign({ evid: 218 }, params));
    };
    /**
    * @typedef {Object} videoMakerSaveVideoButtonClickParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} saveCorrelationId - unique id for the session when video saved (different from correlation In 206)
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    * @property {string} style - style
    * @property {string} videoId - unique id for each video created
    **/
    /**
     * Name: videoMaker.saveVideo.button.click. Evid: 208.
     * Event description: User click on save video button.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * saveCorrelationId - Type: string. Desc: unique id for the session when video saved (different from correlation In 206)
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     *
     * style - Type: string. Desc: style
     *
     * videoId - Type: string. Desc: unique id for each video created
     * @param {videoMakerSaveVideoButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerSaveVideoButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 208 }, params));
    };
    /**
    * @typedef {Object} videoMakerAppLoadedParams
    * @property {string} context - null
    * @property {string} entityId - product_id from stores
    * @property {boolean} isFirst - If app loaded for the first time in site
    * @property {number} loadingTime - page loading time
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    **/
    /**
     * Name: videoMaker.app.loaded. Evid: 201.
     * Event description: Video maker modal loaded - only to welcome screen.
    
     * context - Type: string.
     *
     * entityId - Type: string. Desc: product_id from stores
     *
     * isFirst - Type: bool. Desc: If app loaded for the first time in site
     *
     * loadingTime - Type: numeric. Desc: page loading time
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     * @param {videoMakerAppLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerAppLoaded = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    /**
    * @typedef {Object} videoMakerPageViewParams
    * @property {string} context - null
    * @property {GUID} msid - msid
    * @property {string} origin - ADI / Editor / BM_Editor / BM_ADI
    * @property {string} pageName - page name
    * @property {string} previousPage - prev page
    * @property {string} sessionId - unique Id for each time user open the maker
    * @property {string} source - From where maker opened (stores, MM etc.)
    **/
    /**
     * Name: videoMaker.page.view. Evid: 227.
     * Event description: Generic event for page view in video maker app.
    
     * context - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ADI / Editor / BM_Editor / BM_ADI
     *
     * pageName - Type: string. Desc: page name
     *
     * previousPage - Type: string. Desc: prev page
     *
     * sessionId - Type: string. Desc: unique Id for each time user open the maker
     *
     * source - Type: string. Desc: From where maker opened (stores, MM etc.)
     * @param {videoMakerPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.videoMakerPageView = function (params) {
        return this.bi.log(__assign({ evid: 227 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 84,
        endpoint: 'video-maker'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map